<div class="action">
    <app-popup-top-line></app-popup-top-line>
    <div class="title-row">
        <div class="title">{{ "playbooks.actions" | labelsProvider }}</div>
        <img src="assets/images/common/cancel.svg" (click)="closeWindow()" />
    </div>
    <div class="content">
        <div class="left">
            <div class="title">
                {{ "playbooks.action" | labelsProvider }}
                {{ "common.list" | labelsProvider }}
            </div>
            <div
                class="action-option"
                *ngFor="let option of actionOptions"
                [ngClass]="{
                    selected: option.type === selectedAction,
                    disabled: option.disabled,
                }"
                (click)="onActionSelected(option)"
                [matTooltip]="option.tooltip ? option.tooltip : ''"
                matTooltipPosition="above"
                matTooltipClass="tooltip-container">
                <div class="action-option-title">{{ option.name }}</div>
                <img *ngIf="option.type === selectedAction" class="action-option-selected" src="assets/images/common/selected.svg" />
            </div>
        </div>
        <div class="right">
            <div class="title">
                {{ "playbooks.action" | labelsProvider }}
                {{ "common.properties" | labelsProvider }}
                {{ "common.settings" | labelsProvider }}
            </div>
            <div>
                <app-send-email-action
                    *ngIf="selectedAction === actionTypes.sendEmail"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [trigger]="actionInput.trigger">
                </app-send-email-action>
                <app-send-webhook-action
                    *ngIf="selectedAction === actionTypes.sendWebhook"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType">
                </app-send-webhook-action>
                <app-add-owner-action
                    *ngIf="!!(showAddOwnerAction$ | async)"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType">
                </app-add-owner-action>
                <app-remove-permissions-action
                    *ngIf="!!(showRemovePermissionsAction$ | async)"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType">
                </app-remove-permissions-action>
                <app-isolate-resource-action *ngIf="!!(showIsolateResourceAction$ | async)"> </app-isolate-resource-action>
                <app-remove-access-action
                    *ngIf="showRemoveAccessAction$ | async"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType">
                </app-remove-access-action>
                <app-wait-action
                    *ngIf="selectedAction === actionTypes.wait"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType"></app-wait-action>
                <app-secure-flow-steps-action
                    *ngIf="selectedAction === actionTypes.secureFlowSteps"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType"></app-secure-flow-steps-action>
                <app-set-copilot-authentication-action
                    *ngIf="selectedAction === actionTypes.setCopilotAuthentication"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType"></app-set-copilot-authentication-action>
                <app-add-label-action
                    *ngIf="selectedAction === actionTypes.addLabel"
                    [fg]="fg"
                    [playbooksActionInput]="actionFormInput"
                    [triggerType]="actionInput.trigger.triggerType"></app-add-label-action>
            </div>
        </div>
    </div>
    <div class="buttons-container" *ngIf="selectedAction">
        <div class="cancel" (click)="closeWindow()">
            {{ "common.cancel" | labelsProvider }}
        </div>
        <div class="confirm" [ngClass]="{ 'confirm-disabled': fg.invalid }" (click)="createOrUpdate()" cdkFocusInitial>
            <span>{{ playbookAction ? ("common.save" | labelsProvider) : ("common.create" | labelsProvider) }}</span>
        </div>
    </div>
</div>
